module.exports = __webpack_public_path__ + "static/gallery-customize-7ba3359f700678761a82e784892d8e88.png";